import React from "react";
import PropTypes from "prop-types";

export default function Gear(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3749 15C26.3749 14.5163 26.3303 14.0325 26.2664 13.5488C26.2238 13.2207 26.3613 12.8945 26.6308 12.6899L30 10.1324L26.8302 4.82807L22.8626 6.37309C22.545 6.49869 22.1791 6.45 21.9061 6.24372C21.114 5.64747 20.2795 5.17497 19.352 4.7981C19.0363 4.67066 18.8137 4.39126 18.7672 4.06501L18.1766 0H11.7072L11.2309 4.08751C11.1844 4.41191 10.9657 4.68938 10.6539 4.81876C9.71285 5.20881 8.85112 5.69818 8.09404 6.26815C7.81902 6.4725 7.45505 6.52128 7.13746 6.39753L3.1699 4.85251L9.07159e-05 10.1569L3.36932 12.7144C3.64034 12.9187 3.77595 13.2468 3.73138 13.5768C3.66748 14.0381 3.62292 14.5181 3.62292 15C3.62292 15.4837 3.66748 15.9675 3.73329 16.4494C3.77586 16.7775 3.63835 17.1038 3.36923 17.3081L0 19.8656L3.16963 25.1701L7.13719 23.6251C7.45668 23.4994 7.82065 23.55 8.09177 23.7563C8.8857 24.3525 9.7222 24.8269 10.6458 25.2019C10.9615 25.3293 11.1842 25.6087 11.2306 25.935L11.8212 30H18.2906L18.7669 25.9125C18.8134 25.5881 19.0321 25.3106 19.3439 25.1812C20.285 24.7893 21.1467 24.3037 21.9038 23.7318C22.1768 23.5256 22.5409 23.4749 22.8604 23.6025L26.8279 25.1475L29.9977 19.8431L26.6285 17.2856C26.3575 17.0813 26.2219 16.7532 26.2664 16.4232C26.3303 15.9619 26.3749 15.4819 26.3749 15ZM14.9989 20.625C18.2071 20.625 20.8079 18.1066 20.8079 15C20.8079 11.8935 18.2071 9.37507 14.9989 9.37507C11.7906 9.37507 9.18985 11.8935 9.18985 15C9.18985 18.1066 11.7906 20.625 14.9989 20.625Z"
        fill="#063AC9"
      />
    </svg>
  );
}

Gear.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Gear.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
